import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

/**
 * Strips trailing slashes before route matching so `/username/` resolves the same as `/username`.
 * Static hosts (S3/CloudFront) often 301 `/username` → `/username/`; without this, `:id` may not
 * match and the wildcard 404 route renders briefly during hydration.
 */
@Injectable()
export class TrailingSlashUrlSerializer implements UrlSerializer {
  private readonly defaultSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    return this.defaultSerializer.parse(this.removeTrailingSlash(url));
  }

  serialize(tree: UrlTree): string {
    return this.defaultSerializer.serialize(tree);
  }

  private removeTrailingSlash(url: string): string {
    if (!url || url === '/') {
      return url;
    }

    const hashIndex = url.indexOf('#');
    const queryIndex = url.indexOf('?');
    const pathEnd = Math.min(
      hashIndex === -1 ? url.length : hashIndex,
      queryIndex === -1 ? url.length : queryIndex
    );
    let path = url.substring(0, pathEnd);
    const suffix = url.substring(pathEnd);

    if (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    return path + suffix;
  }
}
